<template>
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <!-- Robot head -->
        <rect x="8" y="12" width="24" height="18" rx="4" fill="#7c3aed" />
        <!-- Antenna -->
        <line x1="20" y1="12" x2="20" y2="6" stroke="#7c3aed" stroke-width="2" stroke-linecap="round" />
        <circle cx="20" cy="5" r="2.5" fill="#a78bfa" />
        <!-- Eyes -->
        <circle cx="14.5" cy="20" r="2.5" fill="#ede9fe" />
        <circle cx="25.5" cy="20" r="2.5" fill="#ede9fe" />
        <circle cx="14.5" cy="20" r="1" fill="#4c1d95" />
        <circle cx="25.5" cy="20" r="1" fill="#4c1d95" />
        <!-- Mouth -->
        <rect x="15" y="25" width="10" height="2" rx="1" fill="#c4b5fd" />
        <!-- Sparkle left -->
        <path d="M4 8l1.2-2.4L7.6 4.4 5.2 3.2 4 0.8 2.8 3.2 0.4 4.4l2.4 1.2z" fill="#a78bfa" />
        <!-- Sparkle right -->
        <path d="M35 10l0.9-1.8 1.8-0.9-1.8-0.9L35 4.6l-0.9 1.8-1.8 0.9 1.8 0.9z" fill="#c4b5fd" />
        <!-- Sparkle bottom-right -->
        <path d="M36 28l0.7-1.4 1.4-0.7-1.4-0.7L36 23.8l-0.7 1.4-1.4 0.7 1.4 0.7z" fill="#ddd6fe" />
    </svg>
</template>

<script>
export default {
    name: "CopilotPromptsIcon",
};
</script>
